/* =====================================================================
   v2 — Ürün sayfası: paket seçimi, şeffaf tutar, yapışkan çubuk
   Kaynak: fmk/bigione.html · Bkz. brief §4

   Paket seçimi mağazadaki mevcut paket sistemine bağlıdır:
   - data-mode="variant" -> gerçek varyant, sepet formu ile eklenir
   - data-mode="bundle"  -> /pages/indirimli-hazir-paketler/<handle>
                            seçici sayfasına götürür; indirim Shopify
                            otomatik indirimlerinden uygulanır.
   ===================================================================== */
class V2Product extends HTMLElement {
  connectedCallback() {
    this.packs = this.querySelector('[data-v2-packs]');
    this.moneyFormat = this.dataset.moneyFormat || '{{amount}}';
    this.installments = parseInt(this.dataset.installments, 10) || 1;

    this.initGallery();
    /* initBarCta, initPacks içinden çağrılıyor: alt bardaki butonun fiyatını
       ilk apply() yazıyor ve apply initPacks'in sonunda çalışıyor. */
    if (this.packs) this.initPacks();
  }

  /* ---------------- Para biçimi ---------------- */
  formatMoney(cents) {
    var value = Math.round(Number(cents) || 0);
    var format = this.moneyFormat;

    function withDelimiters(number, precision, thousands, decimal) {
      number = (number / 100).toFixed(precision);
      var parts = number.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return precision && parts[1] ? whole + decimal + parts[1] : whole;
    }

    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    var match = format.match(placeholder);
    var name = match ? match[1] : 'amount';
    var formatted;

    switch (name) {
      case 'amount_no_decimals':
        formatted = withDelimiters(value, 0, ',', '.');
        break;
      case 'amount_with_comma_separator':
        formatted = withDelimiters(value, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        formatted = withDelimiters(value, 0, '.', ',');
        break;
      case 'amount_with_space_separator':
        formatted = withDelimiters(value, 2, ' ', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        formatted = withDelimiters(value, 0, ' ', ',');
        break;
      case 'amount_with_apostrophe_separator':
        formatted = withDelimiters(value, 2, "'", '.');
        break;
      default:
        formatted = withDelimiters(value, 2, ',', '.');
    }

    return format.replace(placeholder, formatted);
  }

  /* ---------------- Galeri ---------------- */
  initGallery() {
    var thumbs = this.querySelector('[data-v2-gal-thumbs]');
    var main = this.querySelector('[data-v2-gal-main]');
    if (!main) return;

    this.galMain = main;
    this.galStrip = thumbs;
    this.galThumbs = thumbs ? Array.prototype.slice.call(thumbs.querySelectorAll('.v2-pdp__thumb')) : [];

    if (thumbs) {
      thumbs.addEventListener('click', (event) => {
        var btn = event.target.closest('.v2-pdp__thumb');
        if (btn) this.showGalleryImage(this.galThumbs.indexOf(btn));
      });
    }

    if (this.galThumbs.length > 1) this.initGallerySwipe();
  }

  /* Küçük görsel tıklaması ve kaydırma aynı yerden geçsin diye ayrıldı. */
  showGalleryImage(index) {
    if (index < 0 || index >= this.galThumbs.length) return;
    var btn = this.galThumbs[index];
    var main = this.galMain;

    this.galThumbs.forEach((t) => {
      t.classList.toggle('is-on', t === btn);
    });

    var img = main.querySelector('img');
    if (!img) {
      var placeholder = main.querySelector('svg');
      if (placeholder) placeholder.remove();
      img = document.createElement('img');
      img.sizes = '(min-width: 1024px) 50vw, 100vw';
      main.appendChild(img);
    }
    // srcset'i de degistirmek sart: yalnizca src atanirsa tarayici
    // srcset adaylarini kullanmaya devam eder ve ana gorsel hic degismez.
    if (btn.dataset.srcset) {
      img.srcset = btn.dataset.srcset;
    } else {
      img.removeAttribute('srcset');
    }
    img.src = btn.dataset.src;
    img.alt = btn.dataset.alt || '';

    // Etkin küçük görseli şeritte ortala; sayfayı oynatmamak için
    // scrollIntoView yerine şeridin kendi scrollLeft'ini kullanıyoruz.
    var strip = this.galStrip;
    if (strip && strip.scrollWidth > strip.clientWidth) {
      var target = btn.offsetLeft - (strip.clientWidth - btn.offsetWidth) / 2;
      if (strip.scrollTo) {
        strip.scrollTo({ left: target, behavior: 'smooth' });
      } else {
        strip.scrollLeft = target;
      }
    }
  }

  /* Ana görselde sağa/sola sürükleyerek gezinme. */
  initGallerySwipe() {
    var main = this.galMain;
    var startX = 0;
    var delta = 0;
    var dragging = false;
    var pointer = null;

    var currentIndex = () => {
      for (var i = 0; i < this.galThumbs.length; i++) {
        if (this.galThumbs[i].classList.contains('is-on')) return i;
      }
      return 0;
    };

    var offset = (px) => {
      var img = main.querySelector('img');
      if (img) img.style.transform = px ? 'translateX(' + px + 'px)' : '';
    };

    main.addEventListener('pointerdown', (event) => {
      if (event.pointerType === 'mouse' && event.button !== 0) return;
      dragging = true;
      startX = event.clientX;
      delta = 0;
      pointer = event.pointerId;
      if (main.setPointerCapture) main.setPointerCapture(pointer);
      main.classList.add('is-dragging');
    });

    main.addEventListener('pointermove', (event) => {
      if (!dragging) return;
      delta = event.clientX - startX;
      // Sönümlü takip: parmak/imleç kadar değil, üçte biri kadar kayar.
      offset(delta * 0.35);
    });

    var finish = () => {
      if (!dragging) return;
      dragging = false;
      main.classList.remove('is-dragging');
      offset(0);
      // 45px altındaki hareketler tıklama sayılır, görsel yerine oturur.
      if (Math.abs(delta) > 45) {
        this.showGalleryImage(currentIndex() + (delta < 0 ? 1 : -1));
      }
      delta = 0;
    };

    main.addEventListener('pointerup', finish);
    main.addEventListener('pointercancel', finish);
    main.addEventListener('lostpointercapture', finish);
  }

  /* ---------------- Paket seçimi ---------------- */
  initPacks() {
    this.subtotal = this.querySelector('[data-v2-calc-subtotal]');
    this.discountRow = this.querySelector('[data-v2-calc-discount-row]');
    this.discount = this.querySelector('[data-v2-calc-discount]');
    this.total = this.querySelector('[data-v2-calc-total]');
    this.instHead = this.querySelector('[data-v2-inst-head]');
    this.instBody = this.querySelector('[data-v2-inst-body]');

    this.form = this.querySelector('[data-v2-atc]') ? this.querySelector('.v2-pdp__form') : null;
    this.atcPrice = this.querySelector('[data-v2-atc-price]');
    this.variantInput = this.querySelector('[data-v2-variant-input]');
    this.bundleCta = this.querySelector('[data-v2-bundle-cta]');
    this.bundlePrice = this.querySelector('[data-v2-bundle-price]');

    this.initBarCta();

    this.packs.addEventListener('click', (event) => {
      var btn = event.target.closest('.v2-pdp__pack');
      if (btn) this.apply(btn);
    });

    this.apply(this.packs.querySelector('.v2-pdp__pack.is-on') || this.packs.querySelector('.v2-pdp__pack'));
  }

  apply(btn) {
    if (!btn) return;

    this.packs.querySelectorAll('.v2-pdp__pack').forEach((p) => {
      p.classList.toggle('is-on', p === btn);
      p.setAttribute('aria-pressed', p === btn ? 'true' : 'false');
    });

    var price = parseInt(btn.dataset.price, 10) || 0;
    var compare = parseInt(btn.dataset.compare, 10) || 0;
    var url = btn.dataset.url || '#';
    var isBundle = btn.dataset.mode === 'bundle';

    /* Şeffaf tutar */
    if (this.subtotal) this.subtotal.textContent = this.formatMoney(compare > price ? compare : price);
    if (this.discountRow) {
      if (compare > price) {
        this.discountRow.hidden = false;
        if (this.discount) this.discount.textContent = '–' + this.formatMoney(compare - price);
      } else {
        this.discountRow.hidden = true;
      }
    }
    if (this.total) this.total.textContent = this.formatMoney(price);

    /* Satın alma: varyant formu ya da paket seçici bağlantısı */
    if (this.form) this.form.hidden = isBundle;
    if (this.bundleCta) {
      this.bundleCta.hidden = !isBundle;
      this.bundleCta.href = url;
    }
    if (isBundle) {
      if (this.bundlePrice) this.bundlePrice.textContent = this.formatMoney(price);
    } else {
      if (this.atcPrice) this.atcPrice.textContent = this.formatMoney(price);
      if (this.variantInput && btn.dataset.variantId) this.variantInput.value = btn.dataset.variantId;
    }

    /* Alt gezinme çubuğundaki "Satın Al" butonu seçimi yansıtır */
    if (this.barCta) {
      this.barCta.dataset.mode = isBundle ? 'bundle' : 'product';
      /* Paket seçiliyse paket sayfasına gerçek bağlantı; cihaz seçiliyse
         çapa satın alma kutusuna — tıklama zaten yakalanıp forma gidiyor,
         çapa yalnızca JS'ten önceki tıklama için emniyet. */
      this.barCta.href = isBundle ? url : '#v2-buy';
      if (this.barCtaPrice) this.barCtaPrice.textContent = this.formatMoney(price);
    }

    this.renderInstallments(price);
  }

  renderInstallments(price) {
    if (!this.instBody || this.installments < 2) return;

    if (this.instHead) {
      this.instHead.textContent = this.formatMoney(Math.round(price / this.installments));
    }

    var rows = '';
    for (var k = 1; k <= this.installments; k++) {
      rows +=
        '<tr><td>' +
        k +
        '</td><td>' +
        this.formatMoney(Math.round(price / k)) +
        '</td><td>' +
        this.formatMoney(price) +
        '</td></tr>';
    }
    this.instBody.innerHTML = rows;
  }

  /* ---------------- Alt çubuktaki satın alma butonu ----------------
     Ürün sayfasında ayrı bir yapışkan satın alma çubuğu vardı; o da mobil
     alt gezinme barı da position:fixed/bottom:0/z-index:80 olduğu için aynı
     şeridi paylaşıyorlardı ve alt bar DOM'da sonra geldiğinden satın alma
     butonunu tamamen örtüyordu.

     Çözüm: ikinci bir çubuk göstermek yerine alt bardaki mevcut "Satın Al"
     butonunu ürün sayfasında ele geçiriyoruz. Alt bar hiç değişmiyor —
     sekmeler, dokunma hedefleri ve yükseklik aynı kalıyor; buton yalnızca
     seçili paketin fiyatını gösterip sepete ekliyor.

     Butonun kendisi alt bar bölümünde (v2-bottombar), yani bu bileşenin
     DIŞINDA render ediliyor; bu yüzden document üzerinden aranıyor. */
  initBarCta() {
    this.barCta = document.querySelector('[data-v2-bb-cta]');
    if (!this.barCta) return;

    /* Fiyat satırı: alt bar ayarlarında fiyat tanımlı değilse <small> hiç
       basılmıyor. Ürün sayfasında fiyatı göstermek işin özü olduğu için
       yoksa oluşturuyoruz. */
    var holder = this.barCta.querySelector('.cta-t');
    this.barCtaPrice = this.barCta.querySelector('.cta-t small');
    if (!this.barCtaPrice && holder) {
      this.barCtaPrice = document.createElement('small');
      holder.appendChild(this.barCtaPrice);
    }

    /* Buton bu bileşenin dışında yaşıyor: tema düzenleyicide bölüm yeniden
       yüklendiğinde connectedCallback tekrar çalışır ve aynı butona ikinci
       bir dinleyici bağlanırdı — tek tıklamada iki kez sepete ekleme. */
    if (this.barCta.dataset.v2Bound === '1') return;
    this.barCta.dataset.v2Bound = '1';

    var cta = this.barCta;
    cta.addEventListener('click', (event) => {
      /* Paket seçiliyken buton paket seçici sayfasına gerçek bağlantı */
      if (cta.dataset.mode === 'bundle') return;
      /* Sepete ekle butonu document üzerinden aranıyor, bu bileşen üzerinden
         değil: dinleyici bir kez bağlanıyor ve bölüm yeniden yüklenirse
         eskisine kapanmış bir referans kopuk düğüme bakardı. */
      var submit = document.querySelector('[data-v2-atc]');
      if (!submit) return;
      event.preventDefault();
      submit.click();
    });
  }
}

if (!customElements.get('v2-product')) {
  customElements.define('v2-product', V2Product);
}
